import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import "../AllPrint.css";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
class SellPrintKurdish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   sell_invoice_obj,
   thirdcolor,
   primary_logo,
   user,
   footer_logo,
   index_sell_contract,
   name_krd,
  } = this.props;
  // Kurdish
  let numberWordsSorani1 =
   sell_invoice_obj.introduction !== undefined &&
   sell_invoice_obj.introduction !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.introduction)
    : "";
  let numberWordsSorani2 =
   sell_invoice_obj.lastPrice !== undefined &&
   sell_invoice_obj.lastPrice !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.lastPrice)
    : 0;
  let numberWordsSorani3 =
   sell_invoice_obj.reject !== undefined && sell_invoice_obj.reject !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.reject)
    : 0;
  let numberWordsSorani4 =
   sell_invoice_obj.pay !== undefined && sell_invoice_obj.pay !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.pay)
    : 0;
  let numberWordsSorani5 =
   sell_invoice_obj.fee !== undefined && sell_invoice_obj.fee !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.fee)
    : 0;
  return (
   <>
    {/* New One */}
    <div className={`${lang === "en" ? "" : " fk "}`}>
     <div className="row">
      <div className="col-12">
       <div className="conn content-containers" id="tbls">
        <div class="row">
         <div class="col-12  ">
          <img
           src={primary_logo}
           alt="logo"
           className="img-fluid img-responsive"
           style={{ width: "100%" }}
          />
         </div>
        </div>
        <div class="row mt-3">
         <div class="col-4">
          <p
           style={{
            fontSize: "22px",
            color: "#2e425d",
            textAlign: "right",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          ></p>
         </div>
         <div class="col-4 d-flex justify-content-center">
          <p
           style={{
            fontSize: "27px",
            color: "#2e425d",
            fontWeight: "bolder",
           }}
           class={`d-flex justify-content-center text-uppercase ${
            lang !== "en" ? "fk" : "fkp"
           } `}
          >
           ({change_Lang("sale and purchase contract")})
          </p>
         </div>
         <div class="col-4 text-right">
          <p
           style={{
            fontSize: "22px",
            color: "#2e425d",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
           <Time
            value={sell_invoice_obj.createdAt}
            format="YYYY-MM-DD"
            style={{
             fontSize: "22px",
             color: "#2e425d",
             fontWeight: "bold",
            }}
           />
           &nbsp;&nbsp;&nbsp;&nbsp;
          </p>
          <p
           style={{
            fontSize: "22px",
            color: "#2e425d",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           {change_Lang("contract number")} #{index_sell_contract}
           &nbsp;&nbsp;&nbsp;&nbsp;
          </p>
         </div>
        </div>
        <div class="row">
         <div class="col-12">
          <div class="form-group row form-inline">
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk"
           >
            {change_Lang("First Party (Seller)")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "23px" }}
            >
             {sell_invoice_obj.firstname}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk"
           >
            {change_Lang("Second Party (Buyer)_")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "23px" }}
            >
             {sell_invoice_obj.secondname}
            </label>
           </div>
           {/* phone */}
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk"
           >
            {change_Lang("phone_number")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "23px" }}
            >
             {sell_invoice_obj.phone1}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk"
           >
            {change_Lang("phone_number")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "23px" }}
            >
             {sell_invoice_obj.phone2}
            </label>
           </div>
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk"
           >
            {" "}
            {change_Lang("first_rule_place")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "23px" }}
            >
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.Place_ku}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 fkk col-form-label"
           >
            {change_Lang("Type of property")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "23px" }}
            >
             {change_Lang(
              sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Property
             )}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 fkk col-form-label"
           >
            {" "}
            {change_Lang("Number of property")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "23px" }}
            >
             {sell_invoice_obj.available_id &&
             sell_invoice_obj.available_id.Property !== "Apartment" ? (
              <>
               {sell_invoice_obj.available_id &&
                sell_invoice_obj.available_id.NOoFProperty}
              </>
             ) : (
              ""
             )}
             {sell_invoice_obj.available_id &&
             sell_invoice_obj.available_id.Property === "Apartment" ? (
              <>
               &nbsp; &nbsp;
               {sell_invoice_obj.available_id &&
                sell_invoice_obj.available_id.block}{" "}
               &nbsp;-&nbsp;
               {sell_invoice_obj.available_id &&
                sell_invoice_obj.available_id.flour}
               &nbsp;-&nbsp;{" "}
               {sell_invoice_obj.available_id &&
                sell_invoice_obj.available_id.NOoFProperty}
               &nbsp;&nbsp;
              </>
             ) : (
              ""
             )}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 fkk col-form-label"
           >
            {" "}
            {change_Lang("Area")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "23px" }}
            >
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.Area}
             &nbsp;م<sup>2</sup>
            </label>
           </div>
          </div>
          <p
           style={{
            fontSize: "22px",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: "50px 0px 0px 0px",
           }}
           id="liniar"
           class="my-3 d-flex justify-content-center fk"
          >
           {change_Lang("agreement")}
          </p>
         </div>
        </div>
        <div className="row ">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              1-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              من ({sell_invoice_obj.firstname}) خاوەن موڵك ڕەزامەندم بە فرۆشتنی
              ئەم موڵكەی لە سەرەوە ئاماژەی پێكراوە بە بڕی &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
               required
               className="text-center"
               prefix={"$"}
              />
              &nbsp;({numberWordsSorani2}
              &nbsp;دۆلاری &nbsp;ئەمریکی).
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              2-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              من ({sell_invoice_obj.secondname}) ڕەزامەندم بە کڕینی ئەم موڵکەی
              لە سەرەوە ئاماژەی پێکراوە بەبڕی &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
               required
               className="text-center"
               prefix={"$"}
              />
              &nbsp;&nbsp; ({numberWordsSorani2}
              &nbsp;دۆلاری &nbsp;ئەمریکی).
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              3-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              لایەنی دووەم بڕی &nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj ? sell_invoice_obj.introduction : 0}
               required
               className="text-center"
               prefix={"$"}
              />
              &nbsp;({numberWordsSorani1}
              &nbsp;دۆلاری&nbsp;ئەمریکی)&nbsp; رادەستی لایەنی یەکەم کرد .
             </td>
            </tr>

            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              4-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              لەسەر لایەنی یەكەم پێویستە ئەم موڵكە ڕادەستی لایەنی دووەم بكات
              دوای وەرگرتنی تەواوی شایستە داراییەکانی لە رێكەوتی &nbsp;
              <Time
               value={sell_invoice_obj.duedate}
               format="YYYY-MM-DD"
               // style={{ color: "black" }}
              />
              .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              5-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              ئەگەر هاتوو لایەنی یەکەم لە ڕێکەوتی دیاریکراودا ئەم موڵکەی ڕادەستی
              لایەنی دووەم نەکرد ئەوە دەبێت پابەند بێت بە پێدانی بڕی&nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.reject}
               className="text-center"
               prefix={"$"}
              />
              &nbsp;({numberWordsSorani3}
              &nbsp;دۆلاری &nbsp;ئەمریکی)&nbsp;وەکوو پێبژاردن (غرامە) بۆ هەر
              رۆژێک .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              6-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              لایەنی یەکەم لەئەستۆیەتی تا بەرواری رادەست کردنی موڵکەکە بە پێدانی
              هەر قەرزێک ئەگەر هەبێت لە خزمەتگوزاری ئاو کارەبا سەبارەت بە موڵکی
              ئاماژە پێکراو .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
              }}
             >
              7-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              ئەگەر هاتوو هەر لایەنێك بە هەر هۆیەك پاشگەز بێتەوە لەم گرێبەستە
              دەبێت بە لایەنەكەی تر قەرەبوو بکاتەوە بە &nbsp;&nbsp;
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.fee}
               className="text-center"
               prefix={"$"}
              />
              &nbsp; ({numberWordsSorani5}
              &nbsp;دۆلاری &nbsp;ئەمریکی) .
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              8-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              تێچوو و ڕسوماتی فرۆشتن و گواستنەوە و جیاكردنەوە و یەكخستن و
              ڕاستكردنەوە و باجی خانووبەرە لەسەر لایەنی یەكەمە بیدات بەپێی یاسا
              ئەگەر تاپۆ بوو. بەڵام ئەگەر تاپۆ نەبوو لایەنی یەكەم پابەندە بە
              پێدانی بڕی تێچوی گواستنەوەی خاوەنداریەتی.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              9-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              تێچووی ڕسوماتی كەشف و تۆماری عەقاری دەكەوێتە سەر لایەنی دووەم بە
              گوێرەی یاسا ئەگەر موڵكەكە تاپۆ بوو. وە ئەگەر تاپۆ نەبوو ئەوە
              لایەنی دووەم بە پێدانی بڕی پارەی بەناوكردن.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <div className="row content-containers" id="tbls_two">
        <div class="col-12  ">
         <img
          src={primary_logo}
          style={{ width: "100%" }}
          alt="logo"
          className="img-fluid img-responsive"
         />
        </div>
       </div>
       <div className="row mt-3">
        <div className="col-12">
         <table className="table">
          <tbody>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             10-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "3px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "22px",
              borderTop: "none",
             }}
            >
             پاش واژوکردن لەسەر ئەم گرێبەستە ئەگەر هاتوو مولکی فرۆشراو تاپۆی
             هەبوو پێویستە لەسەرلایەنی یەکەم کەوا بریکارنامە بدات بە پارێزەر: (
             {sell_invoice_obj.lawman}) بەمەبەستی گواستنەوەی خاوەنداریەتی و
             تۆمارکردنی موڵکی فرۆشراو بۆ لایەنی دووەم .
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             11-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "3px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "22px",
              borderTop: "none",
             }}
            >
             لایەنی یەکەم وە لایەنی دووەم پابەند دەبێ بە پێدانی رێژەی %1 لەنرخی
             موڵکی ئاماژەپێکراو لەم گرێبەستە لەبەرامبەر فرۆشتنی ئەم موڵکە بۆ
             ڕێکخەر .
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             12-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "3px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "22px",
              borderTop: "none",
             }}
            >
             لەکاتی هەبونی هەر کێشەیەک سەبارەت بەناوەرۆکی ئەم گرێبەستە بە
             پێویستە لەسەر هەردوولایەن سەرەتا بە شێوازی دانوستاندن و گفتوگۆ
             کێشەکە چارەسەر بکەن. بەلام ئەگەر چارەسەر نەکرا ئەوا لەرێگەی
             دادگاکانی سلێمانی چارەسەر دەکرێ.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             13-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "3px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "22px",
              borderTop: "none",
             }}
            >
             لایەنی یەکەم وە لایەنی دووەم دوای واژوو کردنی گرێبەست مافی
             داواکردنی عمولەی پێدراویان نی یە .
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             14-
            </th>
            <td
             style={{
              lineHeight: "1.3",
              wordSpacing: "3px",
              color: "black",
              fontWeight: "",
              textAlign: "justify",
              fontSize: "22px",
              borderTop: "none",
             }}
            >
             {name_krd} بەرپرس نییە لە بوونی هەر کێشەیەک کە لەنێوان فرۆشیار و
             کریار دا رووبدات.
            </td>
           </tr>
           {sell_invoice_obj.article_8 !== "" &&
           sell_invoice_obj.article_8 !== undefined ? (
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              15-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "2px",
               color: "black",
               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              {sell_invoice_obj.article_8}
             </td>
            </tr>
           ) : (
            ""
           )}
           {sell_invoice_obj.article_9 !== "" &&
           sell_invoice_obj.article_9 !== undefined ? (
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              16-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",

               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              {sell_invoice_obj.article_9}
             </td>
            </tr>
           ) : (
            ""
           )}
           {sell_invoice_obj.article_10 !== "" &&
           sell_invoice_obj.article_10 !== undefined ? (
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              17-
             </th>
             <td
              style={{
               lineHeight: "1.3",
               wordSpacing: "3px",
               color: "black",

               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              {sell_invoice_obj.article_10}
             </td>
            </tr>
           ) : (
            ""
           )}
          </tbody>
         </table>
        </div>
       </div>
       <div className="form-inline">
        <label
         style={{
          fontSize: "19px",
          color: "black",
          textAlign: "justify",
         }}
         className="form-label d-flex justify-content-start"
        >
         {change_Lang("note")}&nbsp;: {sell_invoice_obj.note}
        </label>
       </div>
       <br /> <br /> <br /> <br /> <br /> <br />
       <div className="row" style={{ width: "100%" }}>
        <div className="form-group d-flex justify-content-center col-4">
         <label
          style={{
           fontSize: "22px",
           color: "#2e425d",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          لایەنی یەکەم (فرۆشیار)
         </label>
        </div>

        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#2e425d",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           ڕێکخەری گرێبەست
          </label>
         </div>
        </div>
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#2e425d",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           لایەنی دووەم (کڕیار)
          </label>
         </div>
        </div>
       </div>
       <div className="row" style={{ width: "100%" }}>
        <div className="col-4 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "22px",
           color: "#000",
          }}
          className="form-label"
         >
          {sell_invoice_obj.firstname}
         </label>
        </div>
        <div className="col-4 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "22px",
           color: "#000",
          }}
          className="form-label"
         >
          {`${sell_invoice_obj.agentId && sell_invoice_obj.agentId.fname} ${
           sell_invoice_obj.agentId && sell_invoice_obj.agentId.lname
          }`}
         </label>
        </div>
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "22px",
            color: "#000",
           }}
           className="form-label"
          >
           {sell_invoice_obj.secondname}
          </label>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
    {/* footer */}
    <div
     style={{
      position: "fixed",
      bottom: 0,
      width: "100%",
     }}
    >
     <img src={footer_logo} alt="logo" width="100%" />
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  index_sell_contract: state.Invoice_Reducer.index_sell_contract,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_krd: state.HelperReducer.name_krd,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(SellPrintKurdish);
